module.exports = __webpack_public_path__ + "img/asia-admin12.59cbe2ca.png";